import { render, staticRenderFns } from "./FooterPersonal.vue?vue&type=template&id=71a4c3cc&scoped=true"
import script from "./FooterPersonal.vue?vue&type=script&lang=js"
export * from "./FooterPersonal.vue?vue&type=script&lang=js"
import style0 from "./FooterPersonal.vue?vue&type=style&index=0&id=71a4c3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a4c3cc",
  null
  
)

export default component.exports